import { render, staticRenderFns } from "./insertFastReceive.vue?vue&type=template&id=528ee3c8"
import script from "./insertFastReceive.vue?vue&type=script&lang=js"
export * from "./insertFastReceive.vue?vue&type=script&lang=js"
import style0 from "./insertFastReceive.vue?vue&type=style&index=0&id=528ee3c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports